export default __webpack_public_path__ + "static/media/prudential.3fe4af42.jpg";